import React from 'react';
import {
  IonPage,
  IonContent,
  IonButton,
  IonImg,
} from '@ionic/react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

interface LanguageSelectionProps {
  onLanguageSelected?: () => void;
}

const LanguageSelection: React.FC<LanguageSelectionProps> = ({ onLanguageSelected }) => {
  const { t, i18n } = useTranslation();
  const history = useHistory();

  const handleLanguageSelect = async (language: string) => {
    await i18n.changeLanguage(language);
    // localStorage is now handled by i18n.on('languageChanged') in config.ts
    
    // If onLanguageSelected prop is provided, call it
    if (onLanguageSelected) {
      onLanguageSelected();
    } else {
      // Otherwise use the default behavior
      history.push('/auth');
    }
  };

  return (
    <IonPage>
      <IonContent>
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          p: 2
        }}>
          <Box
            sx={{
              width: 200,
              height: 200,
              mb: 4,
              animation: 'scaleIn 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards, pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <IonImg
              src="/assets/image/logo.png"
              alt={t('logo_alt')}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                transition: 'transform 0.5s ease-in-out'
              }}
              className="animate-scaleIn"
            />
          </Box>
          
          <Typography 
            variant="h4" 
            sx={{ 
              mb: 4, 
              textAlign: 'center',
              background: 'linear-gradient(45deg, #007AFF, #00E5FF)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              animation: 'gradient 3s ease infinite'
            }}
          >
            {t('language.select_language')}
          </Typography>

          <Box sx={{ 
            width: '100%', 
            maxWidth: 320,
            display: 'flex',
            flexDirection: 'column',
            gap: 2
          }}>
            <IonButton
              expand="block"
              size="large"
              onClick={() => handleLanguageSelect('en')}
            >
              {t('language.english')}
            </IonButton>

            <IonButton
              expand="block"
              size="large"
              onClick={() => handleLanguageSelect('fr')}
            >
              {t('language.french')}
            </IonButton>
          </Box>
        </Box>
      </IonContent>
    </IonPage>
  );
};

export default LanguageSelection;
